import { FEATURED_THERAPISTS_COUNT } from "@klarify/constants";
import type { FeaturedDirectoryEntry } from "@klarify/types";
import { Trans } from "@lingui/react/macro";
import { FeaturedTherapistCard } from "./featured-therapist-card";

/**
 * Paid-placement row above the organic grid on page 1 of `/therapists`. The
 * caller decides visibility (server mode only); this renders nothing when empty.
 */
export const FeaturedTherapistsRow = ({
	entries,
}: {
	entries: FeaturedDirectoryEntry[];
}) => {
	if (entries.length === 0) {
		return null;
	}
	return (
		<section
			className="mb-6 sm:mb-8"
			aria-labelledby="featured-therapists-heading"
		>
			<h2
				id="featured-therapists-heading"
				className="mb-3.5 font-medium text-klarify-neutral-500 text-xs uppercase tracking-[0.08em]"
			>
				<Trans>Featured therapists</Trans>
			</h2>
			<ul className="grid grid-cols-1 gap-5 md:grid-cols-2">
				{/* The tracking schema caps `slot` at FEATURED_THERAPISTS_COUNT - 1. */}
				{entries.slice(0, FEATURED_THERAPISTS_COUNT).map((entry, slot) => (
					<FeaturedTherapistCard
						key={entry.href}
						entry={entry}
						slot={slot}
					/>
				))}
			</ul>
		</section>
	);
};

FeaturedTherapistsRow.displayName = "FeaturedTherapistsRow";
